import { Box, Button, Container, Grid, Paper, TextField, Typography } from "@mui/material";
import { CssTextField } from "../utils/CssTextField";
import globalContext from '../context/context'
import { useTranslation } from "react-i18next";
import { useContext, useState } from "react";

const defaultFormData = {
    name: '',
    email: '',
    subject: '',
    message: ''
}

function Contact() {

    const { t } = useTranslation();
    const { setSnack } = useContext(globalContext);

    const [formData, setFormData] = useState(defaultFormData);


    const handleSetFormData = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value})
    }

    const handleSendEmail = () => {

        if(
            formData?.name
            &&formData?.email
            &&formData?.subject
            &&formData?.message
        ){
            setSnack({
                message: 'Fejlesztés folyamatban..',
                severity: 'error',
                open: true
            })
        } else{
            setSnack({
                message: t('Contact.everyFieldRequired'),
                severity: 'error',
                open: true
            })
        }


    }

    return (
        <>
            <Box className="orderElement" sx={{ bgcolor: 'rgba(0,0,0, .2)' }}>
                <Container sx={{ justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex' }} >
                    <Paper className="orderElementPaper" sx={{ width: '100%', p: 3, bgcolor: '#fff' }}>
                        <Box sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '1.5rem', pb: 3 }}>{t("Contact.title")}</Box>
                        <Box>
                            <Grid spacing={2} container>
                                <Grid sm={6} item>
                                    <TextField size="small"
                                        value={formData.name}
                                        name="name"
                                        variant="outlined"
                                        onChange={handleSetFormData}
                                        sx={{ mt: 1 }} fullWidth label={t("Contact.name")} />

                                    <TextField size="small"
                                        value={formData.email}
                                        name="email"
                                        onChange={handleSetFormData}
                                        sx={{ mt: 1.75 }} fullWidth variant="outlined" label={t("Contact.email")} />

                                    <TextField size="small"
                                        value={formData.subject}
                                        name="subject"
                                        onChange={handleSetFormData}
                                        sx={{ mt: 1.75 }} fullWidth variant="outlined" label={t("Contact.subject")} />
                                </Grid>
                                <Grid sm={6} item>
                                    <Box>
                                        <TextField 
                                            sx={{ mt: 1 }}
                                            rows={5} 
                                            name="message"
                                            onChange={handleSetFormData}
                                            label={t("Contact.message")} fullWidth type="text" multiline />
                                    </Box>
                                </Grid>
                            </Grid>
                            <Box sx={{ mt: 2 }}>
                                <Button fullWidth variant="outlined" onClick={handleSendEmail}>
                                    {t("Contact.send")}
                                </Button>
                            </Box>

                        </Box>
                    </Paper>
                </Container>

            </Box>

        </>
    );
}

export default Contact;
